import 'firebase/storage';
import { storage } from './firebaseConfig';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { UploadFileInfo } from '@synergetx/puppet-interview-types';

export function uploadAudio(
    audioFile: File,
    path: string,
    progressUpdate: (progress: number) => void,
    onUploadFinish: (fileInfo: UploadFileInfo) => void,
): Promise<string> {
    return new Promise((resolve, reject) => {
        console.log('audio path', { path, full: `${path}_${audioFile.name}` });
        // Create a reference to 'mountains.jpg'
        const audioRef = ref(storage, `${path}_${audioFile.name}`);

        // 'file' comes from the Blob or File API
        const uploadAudio = uploadBytesResumable(audioRef, audioFile);

        // Listen for state changes, errors, and completion of the upload.

        uploadAudio.on(
            'state_changed', // or 'state_changed'
            //   storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            (snapshot) => {
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                // console.log('Upload is ' + progress + '% done');
                progressUpdate(progress);
                switch (snapshot.state) {
                    case 'paused':
                        // console.log('Upload is paused');
                        break;
                    case 'running':
                        // console.log('Upload is running');
                        break;
                }
            },
            (error) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                let errorMessage = 'unknown';
                switch (error.code) {
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        // log(`user doesn't have upload permission`, { error, path });
                        errorMessage = 'unauthorized';
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        errorMessage = 'cancelled';
                        // log({ error, path });
                        break;

                    case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        errorMessage = 'unknown';
                        // log(`Photo Upload Unknown error occurred`, { error, path });
                        break;
                    default:
                        // log(`Unknown error type: ${error.serverResponse}`, {
                        //     error,
                        //     path,
                        // });
                        break;
                }
                reject(`Error occurred: ${errorMessage}`);
            },
            () => {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                getDownloadURL(uploadAudio.snapshot.ref).then((downloadURL) => {
                    // console.log('File available at', downloadURL);
                    onUploadFinish({
                        url: downloadURL,
                        name: audioFile.name,
                        type: audioFile.type,
                    });
                    resolve(downloadURL);
                });
            },
        );
    });
}

export const getDownloadURLFromPath = async (path: string): Promise<string> => {
    const audioRef = ref(storage, path);
    return getDownloadURL(audioRef);
};
